import * as angular from "angular";
import { SurveyQuestion } from "../../models/survey-question.model";
import { SurveyQuestionService } from "../../services/survey-question.service";
import { SurveyService } from "../../services/survey.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let SurveyQuestionFormComponent = {
    selector: "vcSurveyQuestionForm",
    templateUrl:
        "/angular/components/survey/survey-question-form.component.html",
    bindings: {
        question: "=?",
        sid: "=?",
        deleteSurveyQuestion: "&?",
    },
    controller: class SurveyQuestionFormController {
        // * bindings for typescript compiler *
        public question?: any;
        public sid?: any;
        public deleteSurveyQuestion?: any;
        // ************************************

        private service: SurveyService;
        private surveyQuestionService: SurveyQuestionService;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private $window: any;

        public loading: boolean;
        public survey: any;
        public formats: any;
        public saving = false;

        constructor(
            SurveyService: SurveyService,
            SurveyQuestionService: SurveyQuestionService,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            $window: any
        ) {
            this.service = SurveyService;
            this.surveyQuestionService = SurveyQuestionService;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.$window = $window;

            this.service.formats().then((response: object) => {
                const json = response["data"];
                if (json.success) this.formats = json.data;
            });
        }

        $onInit() {
            this.question = new SurveyQuestion(this.question);
            this.question.sid = this.sid;

            this.service.info(this.question.sid).then((response: object) => {
                const json = response["data"];
                this.loading = false;
                if (json.success) {
                    this.survey = json.data;
                } else {
                    this.$window.location = "./#/survey/";
                }
            });
        }

        openErrorDialog(ev?: object): void {
            let dialog = this.dialog
                .alert()
                .textContent(
                    "Sorry but you can't delete the only question associated with a survey!"
                )
                .targetEvent(ev)
                .ok("OK");
            this.dialog.showPreConfiguredDialog(dialog);
        }

        save(): void {
            if (this.question.sqid) {
                this.updateQuestion();
            } else {
                this.createQuestion();
            }
        }

        updateQuestion(): void {
            this.saving = true;
            this.surveyQuestionService
                .update(this.question)
                .then((response: object) => {
                    const json = response["data"];
                    this.saving = false;
                    if (json.success) {
                        this.dialog.hide(json.data);
                        this.toast.success("Question updated");
                    } else {
                        this.toast.error();
                    }
                });
        }

        createQuestion(): void {
            this.saving = true;
            this.surveyQuestionService
                .create(this.question)
                .then((response: object) => {
                    const json = response["data"];
                    this.saving = false;
                    if (json.success) {
                        this.dialog.hide(json.data);
                        this.toast.success("Question created");
                    } else {
                        this.toast.error();
                    }
                });
        }

        deleteQuestion(ev: object, question: object): void {
            if (this.survey.questions.length <= 1) {
                this.openErrorDialog();
            } else {
                this.deleteSurveyQuestion({ question: question, ev: ev });
                this.dialog.hide("delete");
            }
        }

        addOption(ev: object): void {
            const title =
                this.question.atid == 1
                    ? "Add multiple choice option"
                    : "Add checklist option";
            let confirm = this.dialog
                .prompt()
                .title(title)
                .placeholder("Option")
                .targetEvent(ev)
                .multiple(true)
                .required(true)
                .ok("Confirm")
                .cancel("Cancel");
            this.dialog
                .showPreConfiguredDialog(confirm)
                .then((result: object) => {
                    this.question.choices.push({ aname: result });
                });
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("survey")
    .component(
        SurveyQuestionFormComponent.selector,
        SurveyQuestionFormComponent
    );
